"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCertifierClientFacade = void 0;
const autocertifier_client_1 = require("@streamr/autocertifier-client");
const ListeningRpcCommunicator_1 = require("../../transport/ListeningRpcCommunicator");
const utils_1 = require("@streamr/utils");
const START_TIMEOUT = 60 * 1000;
const defaultAutoCertifierClientFactory = (configFile, autoCertifierUrl, autoCertifierRpcCommunicator, wsServerPort) => new autocertifier_client_1.AutoCertifierClient(configFile, wsServerPort, autoCertifierUrl, (_serviceId, rpcMethodName, method) => {
    autoCertifierRpcCommunicator.registerRpcMethod(autocertifier_client_1.HasSessionRequest, autocertifier_client_1.HasSessionResponse, rpcMethodName, method);
});
const logger = new utils_1.Logger(module);
class AutoCertifierClientFacade {
    autoCertifierClient;
    rpcCommunicator;
    options;
    constructor(options) {
        this.options = options;
        this.rpcCommunicator = new ListeningRpcCommunicator_1.ListeningRpcCommunicator(autocertifier_client_1.SERVICE_ID, options.transport);
        this.autoCertifierClient = options.createClientFactory ? options.createClientFactory()
            : defaultAutoCertifierClientFactory(options.configFile, options.url, this.rpcCommunicator, options.wsServerPort);
    }
    async start() {
        this.autoCertifierClient.on('updatedCertificate', (subdomain) => {
            this.options.setHost(subdomain.fqdn);
            this.options.updateCertificate(subdomain.certificate, subdomain.privateKey);
            logger.trace(`Updated certificate`);
        });
        await Promise.all([
            (0, utils_1.waitForEvent3)(this.autoCertifierClient, 'updatedCertificate', START_TIMEOUT),
            this.autoCertifierClient.start()
        ]);
    }
    stop() {
        this.autoCertifierClient.stop();
        this.rpcCommunicator.destroy();
    }
}
exports.AutoCertifierClientFacade = AutoCertifierClientFacade;
//# sourceMappingURL=AutoCertifierClientFacade.js.map